import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').filter('untilDate', uniqueFilter);

    function uniqueFilter() {
        return function (items, to) {
            if (to === undefined || to === null || to === '' || to === '!!') {
                return items;
            }

            var df = new Date(1970, 1, 1, 0, 0, 0);
            var dt = new Date(to);
            var result = [];
            for (var i = 0; i < items.length; i++) {
                var tf = new Date(items[i].validity.start),
                    tt = new Date(items[i].validity.end);
                if (tf > df && tt < dt) {
                    result.push(items[i]);
                }
            }
            return result;
        };
    }
})();
